module.exports = __webpack_public_path__ + "static/img/qujian-tips-3.140fc6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qujian-tips-3.jpg
// module id = 1VpS
// module chunks = 1